<template>
    <div class="candle-stage">
        <svg id="candle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513.28 610.17">
            <path
                id="stick"
                d="M199.55,317.53c-2.27.2-4.63.07-6.79.67-11.58,3.22-21.3-4.32-20.04-16.48.54-5.24,3.27-10.29,5.24-15.33,2.38-6.12,5.78-11.95,7.35-18.25,2.33-9.29-2.05-17.15-7.55-24.38-1-1.31-2.09-2.62-2.78-4.09-3.7-7.84-3.79-17.68,9.64-21.16,7.03-1.82,14.64-1.28,21.85-2.6,13.86-2.54,27.67-5.43,41.4-8.62,6.06-1.41,11.82-4.04,17.78-5.91,7.76-2.44,15.58-4.2,21.79,3.33,5.87,7.12,3.7,14.89,1.25,22.48-1.06,3.3-2.68,6.48-4.46,9.47-6.2,10.39-7.47,21.83-7.14,33.53.53,18.55.35,37.2,2.39,55.6,1.35,12.21,5.54,24.22,9.42,36.01,3.04,9.22,2.15,17.58-5.4,23.54-5.2,4.1-6.84,8.82-6.79,15.23.23,29.79.09,59.59.06,89.39,0,8.73-2.82,11.48-11.6,11.48-21.91,0-43.83,0-65.74-.02-1.47,0-2.95.02-4.41-.13-6.59-.7-8.66-2.9-8.7-9.59-.08-13.24-.06-26.48-.06-39.73,0-35.86.14-71.73-.07-107.59-.04-7.05,2.23-12.27,7.66-16.71,2.7-2.2,4.44-5.57,6.62-8.42-.3-.56-.61-1.13-.91-1.69Z"
            />
            <path
                id="handle"
                d="M101.95,501.93c10.68,0,21.35-.05,32.03.02,5.8.04,10.65,1.39,15.32,5.88,3.23,3.1,9.29,4.5,14.1,4.52,55.59.29,111.18.18,166.77.15,18.02,0,36.05-.07,54.07-.15,5.92-.03,9.5,2.41,12.34,8.03,7.88,15.62,21.1,24.57,38.6,25.25,9.12.35,17.08-4.46,24.24-10.43,16.68-13.91,18.18-35.73,9.66-54.81-5.82-13.05-16.51-20.44-29.94-23.85-13.22-3.36-24.44,1.64-33.58,10.7-4.54,4.5-7.24,10.81-11.06,16.1-1.95,2.7-4.14,5.88-6.97,7.12-2.36,1.03-6.59.48-8.56-1.12-1.59-1.29-1.9-5.4-1.31-7.92,4.45-18.91,16.7-31.23,33.92-39.32,27.71-13.03,55.17,2,68.02,24.7,13.76,24.31,12.43,48.72-3.01,71.32-16.27,23.83-51.23,32.52-76.14,11.99-3.81-3.14-7.45-6.53-10.82-10.12-7.74-8.23-15.11-8.02-22.29.51-4.36,5.18-8.97,10.2-13.91,14.82-7.13,6.67-15.74,9.58-25.65,9.55-61.11-.17-122.23-.14-183.34-.18-2.21,0-4.44-.2-6.62.03-21.9,2.32-38.4-7.52-52.02-23.35-4.8-5.58-10.38-8.22-17.65-8.65-11.16-.67-22.45-.85-32.78-6.36-7.84-4.17-8.83-11.77-1.11-16.01,5.35-2.93,11.55-5.27,17.56-5.85,16.65-1.6,33.41-2.14,50.12-3.09.01.18.02.35.03.53Z"
            />
            <path
                id="flame-1"
                d="M243.33,195.21c-4.16-2.99-1.92-6.53-.88-9.52,6.55-18.81.88-35.12-9.44-50.7-10.98,5.2-21.03,39.24-12.63,57.04-3.17,1.98-4.91.92-7.05-2.06-14.6-20.36-15.07-42.54-7.74-65.16,5.53-17.05,12.64-33.59,19.08-50.34.46-1.19,1.11-2.33,1.81-3.4,4.11-6.24,6.22-6.17,9.65.34,11.08,21.06,19.82,43.09,24.32,66.44,3.93,20.4-.09,39.4-14.48,55.35-.7.78-1.69,1.31-2.65,2.02Z"
            />
            <path
                id="flame-2"
                d="M246.08,205.14c3.77-7.02,8.16-13.79,11.18-21.12,9.93-24.13,15.59-49.13,11.74-75.36-3.45-23.42-13.99-43.19-32.78-58.05-1.89-1.49-5-1.43-7.54-2.09-.44,2.02-1.41,4.09-1.24,6.06,1.62,18.39-4.47,34.27-15.25,48.81-4.48,6.04-8.9,12.19-12.64,18.7-7.74,13.46-8.97,27.53-3.91,42.46,3.36,9.93,8.04,18.87,14.77,26.79,1.66,1.95,3.31,4.27,5.49,5.29,1.8.84,4.38,0,6.61-.08-.11-1.62.02-3.29-.35-4.84-3.37-13.87-3.46-27.81.8-41.38,4.23-13.47,9.34-26.67,14.41-39.85.81-2.12,3.47-3.53,5.27-5.27,1.58,1.95,4.08,3.68,4.59,5.87,4.48,19.31,1.1,38.33-2.27,57.42-1.69,9.54-2.14,19.31-2.82,29-.17,2.35.98,4.78,1.52,7.18.81.16,1.62.31,2.42.47Z"
            />
        </svg>
        <span v-if="isMemberAlready" class="already-agreed">NOTE: You have already agreed to all of this - NO BACKSIES!</span>
    </div>
</template>

<script>
export default {
    name: 'candle-animation',
    methods: {
        getRandomInt(max) {
            return Math.floor(Math.random() * max);
        }
    },
    props: { 
        isMemberAlready: Boolean
    }
}
</script>

<style scoped>
.already-agreed {
    color: white;
    font-weight: bold;
    background-color: rgba(250, 23, 23, 0.7);
    padding: 5px;
    display: inline-block;
    width: 100px;
    font-size: 70%;
    border-radius: 5px;
}

@keyframes flamin {
    from {
        opacity: 0;
    }
    to {
        opacity: 0.9;
    }
}

.candle-stage path {
    fill: var(--the-yellow);
}

.candle-stage #flame-1,
.candle-stage #flame-2,
.candle-stage #flame-3 {
    animation: flamin 1s infinite alternate-reverse;
}

.candle-stage #flame-2,
.candle-stage #flame-3 {
    opacity: 0;
}

.candle-stage #flame-2 {
    animation-delay: 1s;
}

.candle-stage #flame-3 {
    animation-delay: 2s;
}
</style>